import {Card as ChakraCard, CardBody, CardFooter, Heading, Image, Text} from "@chakra-ui/react"
import {StyledButton} from "../../index";

const Card = ({
                  width,
                  height,
                  imgUrl,
                  buttonText= 'Learn More',
                  title,
                  key,
                  description,
                  children
              }) => (
    <ChakraCard
        key={key}
        width={width}
        height={height}
        alignItems={'center'}
        overflow={'hidden'}
        position={'relative'}
        boxShadow={'0px -4px 20px 1px #6F41D280 inset;'}
        bg={'#18191D59'}
        border={'1px solid #23262F'}>
        <CardBody>
            <Image src={imgUrl}/>
            <Heading
                fontSize={{base: 'heading.3xl',lg: 'display.lg'}}
                color={'neutral.300'}>
                {title}
            </Heading>
            <Text
                fontSize={{base: 'body.md',lg: 'heading.3xl'}}
                color={'neutral.500'}>
                {description}
            </Text>
        </CardBody>
        <CardFooter pt={'0'}>
            <StyledButton
                bg={'purple.300'}
                border={'1px solid'}
                borderColor={'purple.500'}
                fontSize={'body.md'}>
                {buttonText}
            </StyledButton>
        </CardFooter>
    </ChakraCard>
)

export default Card;
